export enum Breakpoint {
  MOBILE_XS = 320,
  MOBILE_S = 375,
  MOBILE_L = 430,
  TABLET_PORTRAIT = 768 + 1,
  TABLET_LANDSCAPE = 1024,
  MEDIUM_LARGE = 1360 + 1,
  L = 1440,
  XL = 1920,
}
